import * as React from 'react';
import { GridCell } from '@progress/kendo-react-grid';
import {PendingListContext} from '../common/context';
import { IconButton } from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Link as AnchorLink } from '@material-ui/core';

export default class ApproveRejectUserButton extends GridCell {
    constructor(props: any) {
        super(props);
       
    }

    render() {
        const userId =this.props.dataItem.id;

        return (
            <PendingListContext.Consumer>
                {(value: any) => {
                    return (
                        <td className="actions approveRejectUserButton"> 
                            {/* <button onClick={value.approveRejectUser.bind(this,userId, true)} >Approve</button>
                            <button onClick={value.approveRejectUser.bind(this,userId, false)} >Reject</button> */}

                            <AnchorLink  onClick={value.approveRejectUser.bind(this,userId, true)}>
                                <IconButton className="ApproveItem" title="Approve User">
                                    <CheckCircleIcon />
                                </IconButton>
                            </AnchorLink>

                            <AnchorLink onClick={value.approveRejectUser.bind(this,userId, false)}>
                                <IconButton className="RemoveItem" title="Reject User">
                                    <RemoveCircleIcon />
                                </IconButton>
                            </AnchorLink>
              
                         </td>
                    )}}
                
            </PendingListContext.Consumer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/users/ApproveRejectUserButton.tsx